<template>
<div class="address_container">
    <p>{{value.address_line1}}</p>
    <p v-if="value.address_line2 != null">{{value.address_line2}}</p>
    <p v-if="value.address_line3 != null">{{value.address_line3}}</p>
    <p>{{value.city}}, {{value.state}} {{value.postal_code}}</p>
    <p v-if="value.country != 'US'">{{value.country}}</p>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return {}; }
        },
    },
}
</script>

<style lang="scss" scoped>
.address_container p {
    margin-top: 0em;
    margin-bottom: 0em;
}
</style>